// TODO: TEMPORARY CHANGES - These modifications are temporary and can be reverted before we start working on auth
import type { AuthToken } from '@/types/authAccs'
import { getDomain } from '@/services/util.service'

export function useAuthCustomerAccs() {
    const runtimeConfig = useRuntimeConfig() as {
        public?: {
            spAuthName?: string
            designerBaseUrl?: string
        }
    }
    const designerBaseUrl = runtimeConfig.public?.designerBaseUrl
    const spAuthName = runtimeConfig.public?.spAuthName || 'sp_auth'

    const domain = getDomain(designerBaseUrl)
    const cookie = useCookie<string | null>(spAuthName, {
        maxAge: 60 * 60 * 24 * 30, // 30 days
        path: '/',
        sameSite: 'lax',
        domain: domain,
        httpOnly: false, // client JS can read/write
        secure: false, // must be true on HTTPS (Cloudflare)
    })
    // keep reactive state in sync with cookie

    const customerAuth = useState<AuthToken | null>('auth_customer', (): AuthToken | null => {
        if (!cookie.value) return null

        try {
            const decoded = JSON.parse(atob(cookie.value)) // base64 decode
            return decoded
        } catch {
            return null
        }
    })

    const getAuthCustomer = (): AuthToken | null => {
        const auth = customerAuth.value // already AuthToken | null
        return auth ?? null
    }

    const setAuthCustomer = (token: AuthToken) => {
        const tokenValue = JSON.stringify(token)
        const encoded = btoa(tokenValue)
        cookie.value = encoded
        customerAuth.value = token // update state immediately
    }

    const resetAuthCustomer = (): void => {
        cookie.value = null
        customerAuth.value = null
    }
    const authHeader = (): { Authorization?: string } => {
        const customerAuth = getAuthCustomer()
        if (customerAuth) {
            return { Authorization: 'Bearer ' + customerAuth }
        } else {
            return {}
        }
    }

    return {
        getAuthCustomer,
        setAuthCustomer,
        resetAuthCustomer,
        authHeader,
        // getDomain
    }
}
